import appshellClasses from "@assets/styles/appshell.module.scss";
import inputClasses from "@assets/styles/input.module.scss";
import navlinkClasses from "@assets/styles/navlink.module.scss";
import { AppShell, Button, Checkbox, createTheme, Input, NavLink, rem } from "@mantine/core";

import { mono, yekanFa } from "./fonts";

export const theme = createTheme({
  breakpoints: {
    sm: "36em",
    xs: "20em",
  },
  colors: {
    detail: [
      "#f0f4ff",
      "#e2e6ef",
      "#c3cad7",
      "#a4adc0",
      "#8794ab",
      "#7684a0",
      "#6d7c9b",
      "#5b6a88",
      "#505e7b",
      "#41516f",
    ],
    error: [
      "#ffeaea",
      "#fcd5d5",
      "#f2a8a9",
      "#ea7a7a",
      "#e25353",
      "#de3939",
      "#dd2b2b",
      "#c41e1f",
      "#af171a",
      "#9a0913",
    ],
    gray: [
      "#f2f4f7",
      "#e4e6e8",
      "#c6cbd2",
      "#a4adbc",
      "#8895a9",
      "#76869e",
      "#6c7f9a",
      "#5b6c87",
      "#506079",
      "#41536c",
    ],
    info: [
      "#e3fffc",
      "#d1fbf6",
      "#a6f5ed",
      "#78efe3",
      "#53e9da",
      "#3ce6d5",
      "#2be5d2",
      "#18cbb9",
      "#00b5a4",
      "#009d8e",
    ],
    primary: [
      "#e5f2ff",
      "#cde0ff",
      "#9abeff",
      "#6399ff",
      "#367aff",
      "#1867ff",
      "#005dff",
      "#004ee5",
      "#0045cd",
      "#003ab6",
    ],
    secondary: [
      "#fff9e3",
      "#fff1cd",
      "#ffe29c",
      "#ffd266",
      "#fec43a",
      "#febb1f",
      "#ffb70f",
      "#e3a100",
      "#ca8f00",
      "#af7a00",
    ],
  },
  components: {
    AppShell: AppShell.extend({
      classNames: {
        header: appshellClasses.root,
      },
    }),
    Button: Button.extend({
      defaultProps: {
        fw: "normal",
        fz: "14px",
        loaderProps: { type: "dots" },
      },
    }),
    Input: Input.extend({
      classNames: {
        input: inputClasses.input,
        wrapper: inputClasses.wrapper,
      },
    }),
    NavLink: NavLink.extend({
      classNames: {
        body: navlinkClasses.body,
        root: navlinkClasses.root,
      },
    }),
    Checkbox: Checkbox.extend({
      defaultProps: {
        radius: "sm",
      },
    }),
  },
  defaultRadius: "md",
  fontFamily: `${yekanFa.style.fontFamily} ,-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji`,
  fontFamilyMonospace: `${mono.style.fontFamily}, Monaco, Courier, monospace`,
  fontSizes: {
    lg: rem(24),
    md: rem(18),
    sm: rem(16),
    xl: rem(32),
    xs: rem(14),
  },
  headings: {
    fontFamily: `${yekanFa.style.fontFamily} ,-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji`,
    sizes: {
      h1: { fontSize: rem(58) },
      h2: { fontSize: rem(36) },
      h3: { fontSize: rem(32) },
    },
  },
  primaryColor: "primary",
});
